var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('h2', {
    staticClass: "label"
  }, [_vm._v("等级规则")]), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("什么是成长值")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("成长值是用来评定用户账户的等级，用户可通过消费购物获得成长值，等级越高，所享受的权益就越多。")]), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("等级对照表")]), _vm._m(0), _vm._l(_vm.levelList, function (item, index) {
    return _c('div', {
      key: index + 'level',
      staticClass: "reference-grade",
      class: _vm.levelList.length == index + 1 ? 'bottom-solid' : ''
    }, [_c('span', {
      staticClass: "grade-left"
    }, [_vm._v("Lv." + _vm._s(item.level))]), _c('span', {
      staticClass: "grade-right"
    }, [_vm._v(_vm._s(item.growthValue))])]);
  }), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("成长值发放规则")]), _vm._l(_vm.growthRuleList, function (item, index) {
    return _c('div', {
      key: index + 'growth',
      staticClass: "reference-grade reference-growth",
      class: _vm.growthRuleList.length == index + 1 ? 'bottom-solid' : ''
    }, _vm._l(item.list, function (sub, idx) {
      return _c('div', {
        key: idx + 'orderGrowthValue',
        staticClass: "orderGrowthValue"
      }, [sub === 1 ? _c('span', {
        staticClass: "grade-left"
      }, [_vm._v("每单笔消费" + _vm._s(item.payAmount) + "元")]) : _vm._e(), sub === 2 ? _c('span', {
        staticClass: "grade-left"
      }, [_vm._v("每成交" + _vm._s(item.orderBills) + "笔")]) : _vm._e(), sub === 1 ? _c('span', {
        staticClass: "grade-right"
      }, [_vm._v("获得" + _vm._s(item.payGrowthValue) + "个成长值")]) : _vm._e(), sub === 2 ? _c('span', {
        staticClass: "grade-right"
      }, [_vm._v("获得" + _vm._s(item.orderGrowthValue) + "个成长值")]) : _vm._e()]);
    }), 0);
  }), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("说明")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("1、每单笔消费多少元，获得多少个成长值；")]), _c('p', {
    staticClass: "label-sub"
  }, [_vm._v("（按当天单笔订单的消费额计算，买家确认收货后即可获得成长值。）")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("2、每成交多少笔，获得多少个成长值；")]), _c('p', {
    staticClass: "label-sub"
  }, [_vm._v("（按当天成交总笔数计算，买家确认收货后即可获得成长值。）")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("3、若发起售后，仅退款、退货退款成功后，需扣除交易中获得的成长值。")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("4、支持送成长值的商品可在商品的详情页查看。")])], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "reference-grade"
  }, [_c('span', {
    staticClass: "grade-left"
  }, [_vm._v("等级")]), _c('span', {
    staticClass: "grade-right"
  }, [_vm._v("对应成长值")])]);
}];
export { render, staticRenderFns };